import React from "react";
import { motion } from "framer-motion";
import { Mail, ArrowUpRight } from "lucide-react";

export const JoinTheTeam = () => {
    return (
        <section
            id="careers"
            data-testid="careers-section"
            className="relative bg-tip-black text-tip-white py-24 md:py-36 overflow-hidden"
        >
            <div className="absolute inset-0 grain opacity-40 pointer-events-none" />

            <div className="tip-container relative">
                <div className="flex items-center gap-4 mb-10">
                    <span className="h-[2px] w-12 bg-tip-saffron" />
                    <span className="eyebrow text-white/70">
                        05 — Careers
                    </span>
                </div>

                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    <div className="lg:col-span-7">
                        <motion.h2
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.8 }}
                            className="font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-[104px] leading-[0.95] tracking-[-0.025em]"
                        >
                            Join the{" "}
                            <em className="italic">team</em>
                            <span className="text-tip-saffron">.</span>
                        </motion.h2>

                        <p
                            data-testid="careers-subhead"
                            className="mt-10 max-w-xl font-serif-display text-2xl md:text-[28px] leading-[1.2] tracking-tight text-white/90"
                        >
                            Hiring Gen Z interns to coordinate our Bangalore
                            and Delhi shoots.
                        </p>
                    </div>

                    <div className="lg:col-span-5 lg:pl-10 lg:border-l border-white/15">
                        <p
                            data-testid="careers-apply-line"
                            className="text-lg md:text-xl leading-relaxed text-white/80"
                        >
                            Apply to{" "}
                            <a
                                href="mailto:info@theindiaprojekt.com?subject=Internship%20Application"
                                className="text-tip-saffron font-bold link-underline normal-case"
                                data-testid="careers-email-link"
                            >
                                info@theindiaprojekt.com
                            </a>{" "}
                            with your CV and motivation letter. Come join us on
                            this media revolution!
                        </p>

                        <a
                            href="mailto:info@theindiaprojekt.com?subject=Internship%20Application"
                            data-testid="careers-cta"
                            className="btn-block btn-block-light mt-10 inline-flex"
                        >
                            <Mail size={16} strokeWidth={1.6} />
                            Send Application
                            <ArrowUpRight size={16} strokeWidth={1.6} />
                        </a>

                        <div className="mt-8 grid grid-cols-2 gap-px bg-white/15 border border-white/15">
                            <div className="bg-tip-black p-5">
                                <div className="eyebrow text-white/50">
                                    Location 01
                                </div>
                                <div className="mt-2 font-serif-display text-3xl">
                                    Bangalore
                                </div>
                            </div>
                            <div className="bg-tip-black p-5">
                                <div className="eyebrow text-white/50">
                                    Location 02
                                </div>
                                <div className="mt-2 font-serif-display text-3xl">
                                    Delhi
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
